<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 32"><path d="M42.667 10.958V28c0 2.208-1.792 4-4 4H4c-2.208 0-4-1.792-4-4V10.967c0-.417.475-.65.808-.392 1.867 1.45 4.342 3.292 12.842 9.467 1.758 1.283 4.725 3.983 7.683 3.967 2.975.025 6-2.733 7.692-3.967 8.5-6.175 10.967-8.025 12.833-9.475a.501.501 0 0 1 .808.392zM38.667 0c2.208 0 4 1.792 4 4v1.583c0 .617-.283 1.2-.767 1.575l-.934.733-.138.108c-1.96 1.533-3.978 3.062-13.378 9.884-1.4 1.017-4.183 3.483-6.117 3.45-1.933.033-4.717-2.433-6.117-3.45C5.927 11.142 3.847 9.564 1.908 8.051l-.138-.108-1.003-.785A2.007 2.007 0 0 1 0 5.583V4c0-2.208 1.792-4 4-4z"/></svg>
</template>

<script>
export default {};
</script>
